@if (form().controls.nrOfFinancialYears; as nrOfFinancialYears) {
    <ap-radio-group
        [description]="'income.input.entrepreneurIncome.label' | apKeyOverride: contentKeyMap() | apContent"
        [control]="nrOfFinancialYears | apFormControl"
        data-testid="nrOfFinancialYears"
    >
        <ap-radio-button
            [label]="'income.input.lastFinancialYear' | apKeyOverride: contentKeyMap() | apContent"
            name="financialYears"
            [value]="1"
            [formControl]="nrOfFinancialYears | apFormControl"
        >
        </ap-radio-button>
        <ap-radio-button
            [label]="'income.input.lastFinancialYearMinusOne' | apKeyOverride: contentKeyMap() | apContent"
            name="financialYears"
            [value]="2"
            [formControl]="nrOfFinancialYears | apFormControl"
        >
        </ap-radio-button>
        <ap-radio-button
            [label]="'income.input.lastFinancialYearMinusTwo' | apKeyOverride: contentKeyMap() | apContent"
            name="financialYears"
            [value]="3"
            [formControl]="nrOfFinancialYears | apFormControl"
        >
        </ap-radio-button
    ></ap-radio-group>
    @if (nrOfFinancialYears.value > 0) {
        <fieldset>
            <legend class="ap-heading-3">{{ 'income.input.taxableProfit.label' | apKeyOverride: contentKeyMap() | apContent }}</legend>

            @if (nrOfFinancialYears.value > 2) {
                <ap-amount-input
                    class="ap-display-block ap-margin-bottom-2"
                    data-testid="taxableProfitLastYearMinusTwo"
                    [numberOfDecimals]="numberOfDecimals()"
                    [formControl]="form().controls.taxableProfitLastYearMinusTwo | apFormControl"
                    [helpText]="'income.input.taxableProfit.helpText' | apKeyOverride: contentKeyMap() | apContent"
                    [label]="'income.input.taxableProfit' | apKeyOverride: contentKeyMap() | apContent: { year: '' + (currentYear - 3) }"
                    [messages]="taxableProfitErrorMessages"
                ></ap-amount-input>
            }
            @if (nrOfFinancialYears.value > 1) {
                <ap-amount-input
                    class="ap-display-block ap-margin-bottom-2"
                    data-testid="taxableProfitLastYearMinusOne"
                    [numberOfDecimals]="numberOfDecimals()"
                    [formControl]="form().controls.taxableProfitLastYearMinusOne | apFormControl"
                    [helpText]="'income.input.taxableProfit.helpText' | apKeyOverride: contentKeyMap() | apContent"
                    [label]="'income.input.taxableProfit' | apKeyOverride: contentKeyMap() | apContent: { year: '' + (currentYear - 2) }"
                    [messages]="taxableProfitErrorMessages"
                ></ap-amount-input>
            }
            @if (nrOfFinancialYears.value > 0) {
                <ap-amount-input
                    data-testid="taxableProfitLastYear"
                    [numberOfDecimals]="numberOfDecimals()"
                    [formControl]="form().controls.taxableProfitLastYear | apFormControl"
                    [helpText]="'income.input.taxableProfit.helpText' | apKeyOverride: contentKeyMap() | apContent"
                    [label]="'income.input.taxableProfit' | apKeyOverride: contentKeyMap() | apContent: { year: '' + (currentYear - 1) }"
                    [messages]="taxableProfitErrorMessages"
                ></ap-amount-input>
            }
        </fieldset>
    }
}
